import { take, catchError, map, switchMap } from 'rxjs/operators';
import { getSelectedBusinessLine, OrderBuilderState } from '../../../../../reducers/index';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { IEffect } from '../../../../../../shared/modules/dynamic-effects/effect.interface';
import {
  JobsiteLoadAction,
  JobsiteLoadCompleteAction,
  JobsiteLoadFailAction,
  LOAD_NO_DOCUMENTS,
} from '../../../actions/jobsite-actions/jobsite.actions';
import { IShipmentLocationResponse } from '@cemex-core//cmx-api/models/shipment-location/shipment-location-response';
import { ShipmentLocationsService } from '@cemex-core/cmx-api';
import { PRODUCT_LINE_ID } from '../../../../../../shared/constants/product-lines-ids';
import { IShipmentLocationRequest } from '@cemex-core/cmx-api/models/shipment-location/shipment-location-request';
import { ProductType } from '@cemex-core/cmx-api/models/business-lines/product-type';

@Injectable()
export class JobsiteWithoutDocumentsLoadEffects implements IEffect {
  pointOfDeliveryLoadWithoutDocuments$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_NO_DOCUMENTS),
      switchMap((payload: JobsiteLoadAction) => {
        return this.store
          .select(getSelectedBusinessLine)
          .pipe(take(1))
          .pipe(
            switchMap((businessLine: ProductType) => {
              let request: IShipmentLocationRequest = payload.payload;
              if (parseInt(businessLine.productTypeId.toString(), 10) === PRODUCT_LINE_ID.READY_MIX) {
                request = Object.assign({}, request, { hasDocuments: false });
              }
              return this.shipmentLocationService.getShipmentLocations(request).pipe(
                map((shipmentLocationResponse: IShipmentLocationResponse) => {
                  return new JobsiteLoadCompleteAction(shipmentLocationResponse);
                }),
                catchError((error) => of(new JobsiteLoadFailAction(error))),
              );
            }),
          );
      }),
    ),
  );

  constructor(
    private store: Store<OrderBuilderState>,
    private actions$: Actions,
    private shipmentLocationService: ShipmentLocationsService,
  ) {}
}
